import axios from 'axios';
import { UserRoles } from '../interfaces/user';


export const getMessagesGPT = (user_id?: number | string) => {
  return axios.get('/api/gpt/messages', { params: { user_id } });
};

export const postMessageGPT = (data: FormData) => {
  return axios.post('/api/gpt/message', data);
};

export const getSettingGPT = (
  type:
    | 'main_promt'
    | 'promt'
    | 'dialog_opening'
    | 'avatar'
    | 'model'
    | 'model_2'
    | 'generation_promt'
    | 'improve_promt'
    | 'translate_promt'
    | 'text_translation_promt'
    | 'product_description_promt'
    | 'text_improvement_promt'
    | 'img_improve_promt'
    | 'img_model_promt'
    | 'model_img',
  locale?: string,
  user_role?: UserRoles
) =>
  axios.get('/api/gpt_settings', {
    params: {
      type,
      locale,
      user_role,
    },
  });

export const editSettingGPT = (data: FormData) => axios.post('/api/gpt_settings', data);

export const getChatsGPT = (params: {
  user_id?: number;
  role?: string;
  phone?: string;
  email?: string;
  date_from?: string;
  date_to?: string;
  page?: number;
  per_page?: number;
}) => axios.get('/api/gpt/messages_stat', { params });

export const deleteGPTChat = (user_id?: number) =>
  axios.delete('/api/gpt/chat', { params: { user_id } });

export const getStartMessageGPT = (locale: string) => {
  return axios.get('/api/gpt_settings', { params: { type: 'dialog_opening', locale } });
};

export const getGPTModels = () => axios.get(`/api/gpt_models`);

export const generatedPhotos = (product_id: string, photo_ids: string) => {
  return axios.post(
    '/api/gpt/photo_description',
    {},
    {
      params: { product_id, photo_ids },
    }
  );
};

export const generatedAiText = (text: string, product_id: string) => {
  return axios.post(
    '/api/gpt/text_improvement',
    {},
    {
      params: { text, product_id },
    }
  );
};

export const generatedAiTranslation = (text: string, product_id: string) => {
  return axios.post(
    '/api/gpt/text_translation',
    {},
    {
      params: { text, product_id },
    }
  );
};

export type ImgPromptType = 'img_improve_promt' | 'img_model_promt';

export const improveImage = (photo_id: number | string, prompt_type: ImgPromptType) => {
  return axios.post(
    '/api/gpt/improve_image',
    {},
    {
      params: { photo_id, prompt_type },
    }
  );
};
